import { render } from "./Projects.vue?vue&type=template&id=7a8a24d7"
import script from "./Projects.vue?vue&type=script&lang=ts"
export * from "./Projects.vue?vue&type=script&lang=ts"

import "./Projects.vue?vue&type=style&index=0&id=7a8a24d7&rel=stylesheet&lang=scss"
script.render = render

export default script